import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "src/redux/slices/services";
import PageHero from "src/sections/components/page-hero";
import ReviewsCarousel from "src/sections/reviews/reviews-carousel";
import { usePageMeta } from "src/utils/seo";
import Footer from "../../components/footer/footer";
import ServiceCard from "./service-card";

const ServicesPage = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const lang = i18n.language;

  usePageMeta({
    title: t("services.title"),
    description: t("services.subtitle"),
  });

  const { items, status } = useSelector((state) => state.services.services);

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  return (
    <div className="min-h-screen w-full flex flex-col justify-between bg-kj-dark text-kj-ink">
      <PageHero
        eyebrow={t("services.eyebrow")}
        title={t("services.title")}
        subtitle={t("services.subtitle")}
      />
      {/* aria-busy + role="status": «идёт загрузка» и «загрузилось» слышно,
          а не только видно. Раньше здесь была строка "...Loading" — она же
          показывалась на японской и казахской версиях. */}
      {/* Фотополосы в середине здесь больше нет: услуга продаётся словами —
          что входит, сколько стоит, — и фотография за карточками только
          отвлекала от списка. Фотографии на странице остались одним блоком
          в самом низу — это отзывы, доказательство, а не украшение. */}
      <main
        aria-busy={status === "loading"}
        className="relative z-10 max-w-[1526px] w-full h-full mx-auto flex flex-col gap-y-10 px-4 mt-10 sm:mt-14 mb-8"
      >
        {status === "loading" && (
          <p role="status" className="text-kj-sub">
            {t("common.loading")}
          </p>
        )}

        {status === "error" && (
          <p role="alert" className="text-kj-sub">
            {t("common.loadError")}
          </p>
        )}

        {status !== "loading" && items.length === 0 && (
          <p className="text-kj-sub">{t("services.empty")}</p>
        )}

        {items.length > 0 && (
          // items-stretch: карточки в ряду одной высоты независимо от того,
          // сколько строк занял заголовок после смены языка
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 items-stretch gap-4 sm:gap-5">
            {items.map((service) => (
              <ServiceCard key={service._id} service={service} lang={lang} />
            ))}
          </div>
        )}

        {/* Фото-отзывы в самом низу: человек дочитал, чем мы можем помочь, —
            дальше ему нужны не наши слова, а чужие. */}
        <ReviewsCarousel className="mt-4" />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
